export default __webpack_public_path__ + "media/images/backgrounds/mud_splats/splat-1-d539e713aa013b2e6b822cdb49509219.svg";